import { Component, input, output } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslocoPipe } from '@jsverse/transloco';
import { PERSON_TYPE, personTypeTranslationKeys, SearchResultItem } from '../../../api/app-types/search.app';

@Component({
	selector: 'lvr-participant-item',
	template: `
		@let item = option().item;
		<div class="option">
			@if (showCheckbox()) {
				<mat-checkbox (change)="onSelect(option())" [aria-label]="item.name" [checked]="selected()"> </mat-checkbox>
			}
			<div class="text-block">
				<span class="name">{{ item.name }}, {{ item.firstName }}</span>
				@if (specialization()) {
					<span class="specialization">{{ specialization() }}</span>
				}
				@if (option().personType === PERSON_TYPE.INSTITUTION_PERSON) {
					<span class="position">
						@let institutionBranch = option().institutionBranch;
						@let institutionPersonInstitutionBranches = item.institutionPersonInstitutionBranches;
						@if (institutionBranch) {
							{{ institutionBranch.name }}
						} @else if (institutionPersonInstitutionBranches && institutionPersonInstitutionBranches.length > 0) {
							{{ institutionPersonInstitutionBranches[0].institutionBranch.name }}
						} @else {
							{{ 'global_search.unknown' | transloco }}
						}
					</span>
				} @else if (option().personType === PERSON_TYPE.SPONSOR_CONTACT_PERSON) {
					<span class="position">
						{{ 'base.field.sponsor_contact_person' | transloco }}, {{ item.sponsor?.name }}
					</span>
				} @else {
					<span class="position">{{ mapPersonTypeToKey(option().personType) | transloco }}</span>
				}
			</div>
		</div>
	`,
	styleUrl: './participants.scss',
	imports: [MatCheckboxModule, TranslocoPipe],
})
export class ParticipantItem {
	public readonly option = input.required<SearchResultItem>();
	public readonly selectionChanged = output<SearchResultItem & { selected: boolean }>();
	public readonly selected = input<boolean>(false);
	public readonly showCheckbox = input<boolean>(true);
	public readonly specialization = input<string | undefined>(undefined);

	public get PERSON_TYPE() {
		return PERSON_TYPE;
	}

	public onSelect(value: SearchResultItem) {
		this.selectionChanged.emit({ ...value, selected: this.selected() });
	}

	public mapPersonTypeToKey(pt: PERSON_TYPE) {
		if (this.specialization() !== '' && this.specialization() != null) {
			return this.specialization();
		}

		return personTypeTranslationKeys[pt] || 'unknown';
	}
}
